import {
  Nullable,
  Pass,
  PaymentStatus,
  PaymentStatuses,
} from '@/commons/models';

type FilteredStatus = {
  [prop in PaymentStatuses]?: boolean;
};

export function filterStatus(
  allStatus: PaymentStatus,
  expectedStatus: Array<string>
): FilteredStatus {
  return Object.keys(allStatus).reduce((acc, curr: string) => {
    if (expectedStatus.includes(curr)) {
      acc[curr] = allStatus[curr as keyof PaymentStatus];
    }
    return acc;
  }, {} as { [p: string]: boolean });
}

export function getCurrentStatus(
  filteredStatus: FilteredStatus
): Nullable<PaymentStatuses> {
  return (
    (Object.keys(filteredStatus).find((key) => {
      return filteredStatus[key as PaymentStatuses];
    }) as PaymentStatuses) || null
  );
}

export function getActivePass(passList: Array<Pass>) {
  return passList.find((pass) => pass.active);
}

export function isActivePassUnlimited(passList: Array<Pass>) {
  const activePass = getActivePass(passList);
  if (!activePass) return false;

  return /^unlimited$/i.test(activePass.plan.product.type);
}

export function isMostRecentPassUnlimited(passList: Array<Pass>) {
  if (!passList || passList.length === 0) return false;

  const sortedPasses = [...passList].sort(
    (a: Pass, b: Pass) => b.creationDate - a.creationDate,
  );
  const mostRecentPass = sortedPasses[0];

  return /^unlimited$/i.test(mostRecentPass.plan.product.type);
}
